import React from 'react';
import './Pricing.css';
import { FaDiscord } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import PricingBoxes from './Pricing_Boxes';
import paypalImg from './assets/paypal.png';
import visaImg from './assets/visa.png';
import mastercardImg from './assets/mastercard.png';
import alipayImg from './assets/alipay.png';
import bitcoinImg from './assets/bitcoin.png';
import etherImg from './assets/ether.png';
import skinsImg from './assets/skins.png';
import giftcardsImg from './assets/giftcards.png';
import tetherImg from './assets/tether.png';
import webmoneyImg from './assets/webmoney.png';
import unionpayImg from './assets/unionpay.png';

const Pricing = () => {
  const { t } = useTranslation();

  return (
    <div className="pricing-component" id="pricing">
      {/* Neuer Header-Bereich */}
      <div className="pricing-header">
        <h2>{t('pricing_heading')}</h2>
        <p className="pricing-header-text">{t('pricing_header_text')}</p>
      </div>

      {/* Pricing Boxes direkt ohne Tabs */}
      <PricingBoxes />

      {/* Combined container for Payment Grids and Discord */}
      <div className="pricing-additional-wrapper">
        <div className="additional-box payment-methods-box">
          <span className="payment-label">{t('pay_with')}</span>
          <div className="pricing-payment-grid">
            {[paypalImg, visaImg, mastercardImg, alipayImg, bitcoinImg, etherImg].map((src,i) => (
              <div key={i} className="grid-item">
                <img src={src} alt={`Payment option ${i + 1}`} loading="lazy" />
              </div>
            ))}
          </div>
          <div className="pricing-payment-grid second">
            {[skinsImg, giftcardsImg, tetherImg, webmoneyImg, unionpayImg].map((src,i) => (
              <div key={i} className="grid-item">
                <img src={src} alt={`Additional payment method ${i + 1}`} loading="lazy" />
              </div>
            ))}
          </div>
        </div>
        <div className="additional-box discord-box">
          <span className="support-label">{t('need_support')}</span>
          <button className="pricing-discord-button" onClick={() => window.open('https://discord.com/invite/zEeq3jTzAR', '_blank')}>
            <FaDiscord />
            <span>{t('discord')}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Pricing;
